import { apiRequest } from '../apiSettings';

export const createProjectApi = (title: string) => apiRequest('post')(`/projects/`, { title });

export const createProject = async (title: string) => {
    const data = await createProjectApi(title)
    localStorage.removeItem("activeProjectRole")
    localStorage.removeItem("activeProject")
    return data
}


export const deleteProjectApi = () => apiRequest('delete')(`/projects/delete-active-project`);

export const deleteProject = async () => {
    const data = await deleteProjectApi()
    localStorage.removeItem("activeProjectRole")
    localStorage.removeItem("activeProject")
    return data
}

export const setActiveProjectApi = (projectId: string) => apiRequest('put')(`/projects/${projectId}/set-active`, undefined, true);

export const setActiveProject = async (projectId: string) => {
    const data = await setActiveProjectApi(projectId)
    localStorage.removeItem("activeProjectRole")
    localStorage.removeItem("activeProject")
    return data
}

export const setProjectInactiveApi = () => apiRequest('put')(`/projects/set-inactive`, undefined, true);

export const setProjectInactive = async () => {
    const data = await setProjectInactiveApi()
    localStorage.removeItem("activeProject")
    localStorage.removeItem("activeProjectRole")
    return data
}

export const getAllProjects = () => apiRequest('get')(`/projects/`, undefined, true);

export const getAllRequestedProjects = () => apiRequest('get')(`/projects/requested`, undefined, true);

export const archiveProject = (projectId: string) => apiRequest('put')(`/projects/${projectId}/archive`);

export const addMemberToProject = (projectId: string, email: string, role: string) =>
    apiRequest('post')(`/projects/${projectId}/members/`, { email, role });

// export const setMemberActive = (projectId: string, userId: string) =>
//     apiRequest('put')(`/projects/${projectId}/members/${userId}/set-active`);

export const joinProject = (projectId: string) =>
    apiRequest('put')(`/projects/${projectId}/join`);

export const getActiveProjectApi = () => apiRequest('get')(`/projects/active`, undefined, true);

export const getActiveProject = async () => {
    
    // const activeProjectCache = localStorage.getItem('activeProject');
    // if(activeProjectCache){
    //     return JSON.parse(activeProjectCache)
    // }
    const data = await getActiveProjectApi()
    if(data){
        localStorage.removeItem("activeProjectRole")
        localStorage.setItem("activeProject", JSON.stringify(data))
    }
    return data
}

export const getActiveProjectRoleApi = () => apiRequest('get')(`/projects/active/role`, undefined, true);

export const getActiveProjectRole = async () => {
    // const activeProjectRoleCache = localStorage.getItem('activeProjectRole');
    // if(activeProjectRoleCache){
    //     return JSON.parse(activeProjectRoleCache)
    // }
    const data = await getActiveProjectRoleApi()
    if(typeof data != "string"){
        return null
    }
    if(data){
        localStorage.setItem("activeProjectRole", JSON.stringify(data))
    }
    return data
}

export const getProjectDetails = (projectId: string) => apiRequest('get')(`/projects/${projectId}`, undefined, true);
export const getDocumentById = (documentId: string) => apiRequest('get')(`/document/${documentId}`);

export const getProjectMembers = (projectId: string) => apiRequest('get')(`/projects/${projectId}/members`, undefined, true);

export const deleteMemberFromProject = (projectId: string, userId: string) =>
    apiRequest('delete')(`/projects/${projectId}/members/${userId}`);

// export const getUserByEmail = (email: string) => apiRequest('get')(`/users/email/${email}`);

export const updateInspectionStatus = (inspectionId: string, status: string) => apiRequest('post')(`/update-inspection-status/${inspectionId}`, { status })